import axios from 'axios';
import { useLoadingOverlay } from '../Context/LoadingOverlayContext';
import { useRef, useEffect } from 'react';
import { SecureStorage } from '../Utilities/StorageEncryption';

const useAxiosCall = () => {
    const { showLoadingOverlay, hideLoadingOverlay } = useLoadingOverlay();
    let cancelTokenSources = useRef({});
    
    // Array of URLs for which cancel token should be handled
    const cancelTokenUrls = ['getDataListing/resident','getDataListing/owner', 'getDataListing/prospect', 'getDataListing/vendor'];

    const makeApiCall = async ({ requestData, onSuccess, onError, requestType, url, responseType, loader = true,multipart=false }) => {
        if (loader) {
            showLoadingOverlay();
        }

        try {
            if (cancelTokenUrls.includes(url) && cancelTokenSources.current[url]) {
                cancelTokenSources.current[url].cancel('Cancelled due to another request');
            }

            if (cancelTokenUrls.includes(url)) {
                cancelTokenSources.current[url] = axios.CancelToken.source();
            }

            const tokenKey = JSON.parse(SecureStorage.getItem('tokenKey'));
            const headers = {
                'Content-Type': (multipart)?'multipart/form-data':'application/json',
            };

            if (tokenKey) {
                headers.Authorization = `Bearer ${tokenKey.value}`;
            }

            const axiosConfig = {
                headers,
                responseType: responseType || 'json',
                cancelToken: cancelTokenUrls.includes(url) ? cancelTokenSources.current[url].token : undefined,
            };

            let response;

            if (requestType === 'GET') {
                response = await axios.get(process.env.REACT_APP_API_BASE_URL + url, axiosConfig);
            } else if (requestType === 'POST') {
                response = await axios.post(process.env.REACT_APP_API_BASE_URL + url, requestData, axiosConfig);
            } else {
                // Handle unsupported request types
                throw new Error(`Unsupported request type: ${requestType}`);
            }

            if (response.data.success === false) {
                onError(response.data.message);
            } else {
                onSuccess(response.data, response.headers);
            }
        } catch (error) {       
            if (axios.isCancel(error)) {
                throw new Error('Request canceled');
            } else if (error.response && error.response.status === 402) {
                window.dispatchEvent(new Event('logoutRequired'));
            } else {
                onError('An error occurred. Please try again.');
                console.log('An error occurred:', error);
            }
        } finally {
            hideLoadingOverlay();
        }
    };

    const refreshToken = async () =>  {
        try {
            const refreshTokenValue = SecureStorage.getItem('refreshToken');
            const tokenKey = JSON.parse(SecureStorage.getItem('tokenKey'));
            console.error('Before calling api, refreshTokenValue is ' + tokenKey.value)
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}refreshToken`, {
                    refreshToken: refreshTokenValue,
                    token: tokenKey.value
                }
            );
            // console.log('IM back from refreshtoken', response.data)   
            const tokenData = {
                value: response.data.data.token,
                timestamp: new Date().getTime(),
            };          
            SecureStorage.setItem('tokenKey', JSON.stringify(tokenData))
            SecureStorage.setItem('refreshToken', response.data.data.refreshToken);

            return response.data.data.token;
        } catch (error) {
            console.log('Refresh token error');
        }
    }
    useEffect( () => { 
      const interceptor = axios.interceptors.response.use(
        (response) => response,
        async (error) => {
            console.log('INterceptor in use')
            const originalRequest = error.config;

            if(error.response.status === 401 && !originalRequest._retry) {
                console.log('401 detected');
                console.log('error repsonse', error.response);
                if(error.response.data.Code=='Token_Expired'){
                    window.location.href='/login';
                }
                originalRequest._retry = true;
                const newToken = await refreshToken();
                if(newToken) {
                    console.log('retry request',originalRequest );
                    originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                    return axios(originalRequest);
                } else {
                    console.log('Didnt get a new token')
                }
            }
            return Promise.reject(error)
        }
      );
    
      return () => {
        axios.interceptors.response.eject(interceptor);
      }
    }, [])
    

    return { makeApiCall };
};

export default useAxiosCall;
